import { Action, defaultActions } from '#/common/components/DataGrid';
import { AssetPlan } from '#/graphql/types';

export const actions: Action<AssetPlan>[] = [...defaultActions];
